<template lang="html">
    <div class="container" id="text-page">
      <h1 class="mb-3 page-title">Preguntas frecuentes de los Clientes</h1>

      <div class="content" v-html="row"></div>

      <!-- <div class="content">
        <h5>¿Bazaar Flex es quien fabrica o vende los productos?</h5>
        <p>
          No. Bazaar Flex es una plataforma que conecta a productores mexicanos con compradores internacionales. Cada producto es responsabilidad directa del productor afiliado.
        </p>

        <br />
        <h5>¿Los precios incluyen impuestos o aranceles de importación?</h5>
        <p>
          No. Los precios publicados no incluyen aranceles, impuestos aduanales o tasas aplicables en el país destino. Estos deberán ser cubiertos por el comprador al recibir el producto.
        </p>

        <br />
        <h5>¿Puedo pagar en mi moneda local?</h5>
        <p>
          Puedes ver los precios en tu moneda, pero el cobro final dependerá de la conversión que realice tu entidad financiera o plataforma de pago.
        </p>

        <br />
        <h5>¿Qué pasa si mi pedido llega dañado o no corresponde con lo que compré?</h5>
        <p>
          Puedes enviar una reclamación dentro de las primeras 72 horas tras la entrega, incluyendo evidencia (fotos o video). Nuestro equipo te ayudará a gestionar la devolución o reembolso.
        </p>

        <br />
        <h5>¿Cuánto tarda en llegar un pedido internacional?</h5>
        <p>
          El tiempo estimado varía según el país destino y el método de envío seleccionado. Por lo general, oscila entre 7 y 30 días hábiles.
        </p>

        <br />
        <h5>¿Cómo puedo rastrear mi pedido?</h5>
        <p>
          Una vez que el productor realice el envío, recibirás un número de seguimiento y el enlace para rastrear tu paquete.
        </p>

        <br />
        <h5>¿Qué métodos de pago aceptan?</h5>
        <p>
          Aceptamos tarjetas de crédito y débito internacionales, PayPal, y otras plataformas electrónicas confiables.
        </p>

        <br />
        <h5>¿Puedo cancelar un pedido después de pagarlo?</h5>
        <p>
          Solo se puede cancelar si el pedido aún no ha sido enviado. Una vez despachado, debes solicitar una devolución tras recibirlo.
        </p>

        <br>
        <h5>¿Puedo hacer compras al mayoreo?</h5>
        <p>
          Sí. Algunos productores ofrecen precios especiales para pedidos grandes. Puedes contactarlos directamente desde la ficha del producto o consultar nuestras categorías de mayoreo.
        </p>

        <br>
        <h5>¿Qué pasa si hay un error de traducción en el sitio?</h5>
        <p>
          Hacemos esfuerzos por traducir el contenido correctamente, pero ante cualquier duda prevalece la versión en español del producto o política publicada.
        </p>
      </div> -->
    </div>
  </template>

  <script>
  export default {
    data(){
      return{
        row:null,
      }
    },

    methods: {
      getData: function(){
        axios.get(tools.url('/api/faqs_customers')).then((response)=>{
          this.row = response.data.body;
        }).catch((error)=>{
        })
      },
    },

    mounted(){
        this.getData();
    },
  }
  </script>
